<!--
 * @Author: Nemo
 * @Description: OnCollapsiblePanel组件 - 手风琴式折叠面板基础组件
 * @Date: 2025-04-28
 * @FilePath: /rhcn-checkout-web/src/componentsV2/base/collapsible-panel/index.vue
-->
<template>
  <div class="collapsible-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'OnCollapsiblePanel',
  provide() {
    return {
      collapse: this,
    };
  },
  props: {
    // 当前激活的面板，可以是单个值或数组
    modelValue: {
      type: [String, Number, Array],
      default: '',
    },
    // 是否手风琴模式（同时只能展开一个面板）
    accordion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeNames: [],
    };
  },
  watch: {
    modelValue: {
      handler(val) {
        if (this.accordion) {
          this.activeNames = val ? [val].flat() : [];
        } else {
          this.activeNames = val ? (Array.isArray(val) ? val : [val]) : [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleItemClick(name) {
      if (this.accordion) {
        // 手风琴模式
        if (this.activeNames.includes(name)) {
          // 如果已激活，则关闭
          this.activeNames = [];
          this.$emit('update:modelValue', '');
        } else {
          // 否则激活当前项
          this.activeNames = [name];
          this.$emit('update:modelValue', name);
        }
      } else {
        // 多选模式
        const activeNames = [...this.activeNames];
        const index = activeNames.indexOf(name);

        if (index > -1) {
          activeNames.splice(index, 1);
        } else {
          activeNames.push(name);
        }

        this.activeNames = activeNames;
        this.$emit('update:modelValue', activeNames);
      }
      this.$emit('change', this.activeNames);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.collapsible-container {
  width: 100%;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  overflow: hidden;
}
</style>
